module.exports = __webpack_public_path__ + "assets/img/2.260d937e.png";